import { Injectable } from '@angular/core';
import { BehaviorSubject, debounceTime, filter, share, tap } from 'rxjs';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  Event,
} from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(true);
  public loading$ = this._loading.asObservable();

  public initNavigationTracking(router: Router) {
    const routerEvents$ = router.events.pipe(share());

    let hasEmittedStart = false;

    routerEvents$
      .pipe(
        filter((e): e is NavigationStart => e instanceof NavigationStart),
        tap(() => {
          if (!hasEmittedStart) {
            this._loading.next(true);
            hasEmittedStart = true;
          }
        })
      )
      .subscribe();

    routerEvents$
      .pipe(
        filter(this.isTerminalEvent),
        debounceTime(300), // to allow the app to complete navigation and render
        tap(() => {
          if (hasEmittedStart) {
            this._loading.next(false);
            hasEmittedStart = false;
          }
        })
      )
      .subscribe();
  }

  private isTerminalEvent(
    event: Event
  ): event is NavigationEnd | NavigationCancel | NavigationError {
    return (
      event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError
    );
  }
}
